import * as React from 'react';

export const CheckFat = ({ width = 44, height = 34, fill = "#1E1E1E", ...props }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 44 34" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M42.622 8.79893L18.547 32.8739C17.9845 33.4361 17.2217 33.7519 16.4264 33.7519C15.6311 33.7519 14.8684 33.4361 14.3058 32.8739L0.877048 19.3739C0.315437 18.8115 0 18.0491 0 17.2542C0 16.4594 0.315437 15.697 0.877048 15.1346L4.62705 11.3846C5.18929 10.8247 5.95045 10.5103 6.74392 10.5103C7.5374 10.5103 8.29855 10.8247 8.8608 11.3846L16.5014 18.7946L34.6439 0.875178C35.2062 0.314711 35.9678 0 36.7617 0C37.5557 0 38.3172 0.314711 38.8795 0.875178L42.6202 4.53893C42.9015 4.81769 43.1248 5.1494 43.2773 5.51491C43.4297 5.88042 43.5083 6.2725 43.5085 6.66854C43.5087 7.06457 43.4304 7.45672 43.2783 7.82237C43.1261 8.18801 42.9031 8.51992 42.622 8.79893Z"
        fill={fill}
      />
    </svg>
  );
};
